<template>
	<div>
		<div style="padding-top: 20px; height: calc(100vh - 70px - env(safe-area-inset-bottom)); overflow: auto;">
			<van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="onRefresh">
			  <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载" @load="refreshList">
          <div class="list" v-for="(item, index) in list" :key="index">
            <div class="row-item">
              <div class="item-name">{{item.code}}</div>
              <div class="item-sellName">名称：{{item.name}}</div>
              <div class="item-amount">请款金额：{{item.request_amount.toFixed(2)}}</div>
              <div class="item-amount">申请日期：{{item.date}}</div>
              <!--              <div class="item-good">税目：{{item.vatInvoiceDetails[0].name}}</div>-->
              <!--            <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
            </div>
<!--            <van-icon name="delete-o" size="24" color="#EE0A24" @click="deleteBill(item)"/>-->
          </div>
			  </van-list>
			</van-pull-refresh>
		</div>
		<van-tabbar v-model="active" :fixed="true" :placeholder="false" :safe-area-inset-bottom="true">
		  <van-tabbar-item icon="home-o" route replace to="/invoice">发票</van-tabbar-item>
		  <van-tabbar-item icon="search">报销单</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import InvoiceService from '@/api/invoice/InvoiceService.js' ;
	export default {
		data() {
			return {
        active: 1,
        list: [],
        loading: false,
        finished: false,
        error: false,
        current: 1,
        size: 10,
        total: 0
			}
		},
		onLoad() {
		},
		onShow(){
		},
		methods: {
      onRefresh() {
        this.current = 1
        this.size = 10
        this.list = []
        this.refreshList()
      },
      refreshList() {
        // Vue.cookie.set('token', "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0eXBlIjoiZGluZyIsImV4cCI6MTczMDU1MDY2OSwidXNlcm5hbWUiOiJ3YW5nbWluIn0.8BFrdFyLtyr9b-4J4gDWScpcv-_l_KOBL0z8Qs43OkQ");
        this.loading = true;
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new InvoiceService().myExpenseList({
          current: this.current,
          pageSize: this.size
        }).then(({data}) => {
          this.list.push(...data.records)
          this.total = data.total
          this.loading = false
          this.finished = this.total / this.size <= this.current
          if (!this.finished) {
            this.current += 1
          }
          this.$toast.clear();
        }).catch(()=>{
          this.loading = false;
          this.error = true
          this.$toast.clear();
          // this.finished = true;
        })
      },
			takePic:function(category){
				let that = this;
				uni.chooseImage({
					count: 1,
					sizeType: ['original'],
					sourceType: ['camera','album'],
					success: (res) => {
						uni.showLoading({
							title:'处理中...'
						})
						for(let i=0;i<res.tempFilePaths.length;i++){
							let url = res.tempFilePaths[i];
							uni.uploadFile({
								url: that.$API_HOST + '/upload',
								filePath: url,
								name: 'file',
								formData: {
									'folder': 'bill',
								},
								success: (uploadFileRes) => {
									let res = JSON.parse(uploadFileRes.data);
									uni.hideLoading();
									uni.navigateTo({
										url:`/pages/bill/billPic?category=${category}&type=img&data=${JSON.stringify([res.data])}`
									})
								}
							});
						}
					}
				});
			}
		}
	}
</script>

<style scoped>
.list{
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #EEEEEE;
}
.row-item{
  width: 85%;
  padding: 5px 5px 8px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.item-name{
  width: 280px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #e29700;
}
.item-sellName{
  width: 280px;
  font-size: 11px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-amount{
  font-size: 11px;
  display:block;
  color: #4D4D4D;
}
</style>
